function momentFormat() {
  'ngInject';
  return function(date, format, which) {

    return moment(date)[which || 'utc']().format(format);

  };
}

export { momentFormat };
